import React from 'react';
import moment from 'moment';
import { Spring } from 'react-spring';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { slotActions } from '../../store/actions';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/footer';
import Swal from 'sweetalert2';
import { constants } from '../../Constants';
import { history } from '../../helpers';
import '../../static/css/styles.css';
import { viewSlotConst } from '../../helpers/ConstantID';

class ViewCounselorSlots extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentSlots: [],
		};
	}

	componentWillMount() {
		if (this.props.user.user !== undefined) {
			if (this.props.user.user.role === 1) {
				history.replace('/home');
			} else {
				const { user_id } = this.props.user.user;
				this.props.fetchTimeSlots(user_id);
			}
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.all_slots.items.length > 0) {
			if (nextProps.all_slots.slotDeleted){
				if (this.props.user.user !== undefined) {
						const { user_id } = this.props.user.user;
						this.props.fetchTimeSlots(user_id);
				}				
			}
			
			
			let { items } = nextProps.all_slots;
			const { projects } = this.props.user.user; //Counsellor's allocated projects
			for (var i = 0; i < items.length; i++) {
				const { project_id } = items[i];
				let projectName = [];
				let project = null;
				if (project_id && project_id.indexOf(',') > -1) {
					const allProjects = project_id.split(',');
					allProjects.forEach((p) => {
						project = projects.find((f) => f.id === p);
						projectName.push(project.name);
					});
				} else {
					project = !!project_id ? projects.find((f) => f.id === project_id) : undefined;
					if (project) projectName.push(project.name);
				}
				items[i].project = project ? projectName.join(', ') : null;
			}

			this.setState({
				currentSlots: nextProps.all_slots.items,
			});
		}
		this.setState({
			currentSlots: nextProps.all_slots.items,
		});
	}
	deleteTimeSlot = (slot_id) => {
		const { user_id } = this.props.user.user;
				
		Swal.fire({
			title: constants.DELETE_CONFORM_HEADER_TXT,
			text: constants.SLOT_DELETE_CONFIRM_TXT,
			type: 'question',
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: '#36A692',
			cancelButtonColor: '#d33',
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
			onOpen: function () {
				Swal.getPopup().querySelector('.swal2-confirm').setAttribute('id', 'btnConfirmDeleteSlot');
				Swal.getPopup().querySelector('.swal2-cancel').setAttribute('id', 'btnCancelDeleteSlot');
			},
		}).then((result) => {
			if (result.value) {
				this.props.deleteTimeSlot(slot_id);
			} else {
			}
		});
	};

	createSlotpage = () => {
		const _null = "null";
		history.push(`/counselor/slotpicker`);
	};
	render() {
		const { currentSlots } = this.state;
		const { all_slots } = this.props;
		if (all_slots.loading === false) {
			return (
				<div className="sh-layout">
					<HeaderComponent />
					<div className="sh-patient-dash-comp sh-gnrl-width sh-container-pd10">
						{/* Session Div */}
						<div className="sh-gnrl-container">
							<div className="sh-gnrl-cont-header">
								<h3 className="sh-gnrl-ch-heading">{constants.REGISTERED_SLOTS_TXT}</h3>
							</div>

							<div className="sh-gnrl-cont-content">
								{/* Header for counsellor */}
								{currentSlots.length > 0 ? (
									<div className="sh-gnrl-cc-row">
										<div className="sh-gnrl-col-1 sh-mble-col-1">
											<span className="sh-gnrl-cchc-main-head">{constants.ORGANIZATION_TXT}</span>
										</div>
										<div className="sh-gnrl-col-2 sh-mble-col-2">
											<span className="sh-gnrl-cchc-main-head">{constants.WHEN_TXT}</span>
										</div>
										<div className="sh-gnrl-col-1 sh-mble-col-unset">
											<span className="sh-gnrl-cchc-main-head">
												<i className="fa fa-bars"></i>
											</span>
										</div>
									</div>
								) : (
									<div className="sh-gnrl-cc-row">
										<div className="sh-gnrl-col-2">
											<span className="sh-gnrl-cchc-main-title" id={viewSlotConst.sh_cl_viewslot_msg}>{constants.NO_SLOTS_TXT}</span>
										</div>
									</div>
								)}
								{currentSlots.length > 0
									? currentSlots.map((v, i) => {
											return (
												<div className="sh-gnrl-cc-row">
													<div className="sh-gnrl-col-1 sh-mble-col-1">
														<span className="sh-gnrl-cchc-main-title" id={`${viewSlotConst.sh_cl_viewslot_name}${i}`} >{v.project}</span>
													</div>
													<div className="sh-gnrl-col-2 sh-mble-col-2">
														<span className="sh-gnrl-cchc-main-title" id={`${viewSlotConst.sh_cl_viewslot_time}${i}`}>
															{moment(v.date_time).format('YYYY-MM-DD HH:00:00')}
														</span>
													</div>
													<div className="sh-gnrl-col-1 sh-mble-col-unset">
													
														<button
															className="sh-btn-cancel sh-gnrl-btn-session"
															value={78}
															onClick={() => this.deleteTimeSlot(v.id)}
															id="cancelBtn"
														>
															<span className="sh-text-icon">
																{constants.CANCEL_TXT}
															</span>
															<span className="icon"></span>
														</button>
														
													</div>
												</div>
											);
									  })
									: null}
							</div>
						</div>
					</div>

					<Footer />
				</div>
			);
		} else {
			return <Loading />;
		}
	}
}

function mapStateToProps(state) {
	return {
		user: state.auth,
		users: state.users,
		item: state.item,
		all_slots: state.slots,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchTimeSlots: (counsellor_id) => {
			dispatch(slotActions.fetchTimeSlots(counsellor_id));
		},
		deleteTimeSlot: (slotDetails) => dispatch(slotActions.deleteTimeSlot(slotDetails)),
		
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCounselorSlots);



// WEBPACK FOOTER //
// ./src/screens/ViewCouselorSlots/index.js